import { z } from '@hono/zod-openapi'
import { domainsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertDomain = z.infer<typeof zInsertDomain>
export type SelectDomain = z.infer<typeof zSelectDomain>
export type UpdateDomain = z.infer<typeof zUpdateDomain>
export type QueryDomain = z.infer<typeof zQueryDomain>
export type ColumnsOfDomainsTable = keyof typeof domainsTable._.columns

export const zSelectDomain = createSelectSchema(domainsTable)
export const zInsertDomain = createInsertSchema(domainsTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateDomain = zInsertDomain.partial()
export const zQueryDomain = zInsertDomain
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
